<template>
 <div
    id="providers"
    class="row"
  >
    <v-row justify="center">
      <v-col
        cols="12"
        sm="12"
        md="10"
        lg="9"
      >
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
          @submit.prevent="reset"
          @keydown="form.onKeydown($event)"
        >
            <toolbar
              :title="title"
              :loading="form.busy"
              enctype="multipart/form-data"
              :buttons="buttons"
              @save="save"
              @cancel="cancel"
            />
            <v-layout
              :id="ref"
              class="wrap justify-space-around form-body"
            >
                <v-col
                  cols="12"
                  md="12"
                >
                  <v-file-input
                    v-model="file"
                    accept=".txt,.blade,.php"
                    label="Seleccione para agregar un archivo .txt .blade. php"
                    type="file"
                    ref="file"
                    id="file"
                    :rules="[rules.required]"
                    required
                  />
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-model="form.name"
                    label="Nombre"
                    maxlength="50"
                    :rules="[rules.required]"
                    required
                  />
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-model="form.version"
                    label="Versión"
                    maxlength="15"
                    placeholder="1.0"
                    :rules="[rules.required, rules.versionFormat]"
                    required
                  />
                </v-col>
                <v-col cols="12">
                <v-textarea
                  v-model="form.parameters"
                  label="Parametros"
                  :rules="[rules.required]"
                  @change="UpdateJson"
                  required
                />
                <span>{{ this.titleFormat }}</span>
                <vue-json-pretty :path="'root'" :data="form.data" @click="handleClick"> </vue-json-pretty>
              </v-col>
            </v-layout>
        </v-form>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Form from 'vform';
import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';
import Toolbar from '~/components/Toolbar';

export default {
  middleware: 'auth',
  components: {
    Toolbar,
    VueJsonPretty,
  },
  props: {
    action: { default: '' },
    message: { default: '' },
  },
  data: () => ({
      form: new Form({
        data: {},
        type: 'xsl',
        name: '',
        parameters: '',
        xsl: '',
        version: '',
        active: '1',
        template: 'xsl',
        defaultTemplate: false,
        busy: false,
      }),
      jsonValid: true,
      title: 'Representaciones PDF',
      titleFormat: '',
      items: [
        { value: '00', text: 'Default' },
      ],
      name: '',
      dialog: false,
      file: '',
      valid: false,
      rules: {
        required: (v) => !!v || 'El campo es requerido.',
        versionFormat: (v) => /^[0-9]+[.]{1}[0-9]+$/.test(v) || 'El campo no tiene un formato valido.',
      },
      buttons: [
        {
          id: 'save',
          icon: 'mdi-content-save',
          name: 'Guardar',
          event: 'save',
          color: 'success',
        },
        {
          id: 'cancel',
          icon: 'mdi-close',
          name: 'Volver',
          event: 'cancel',
        },
      ],
      apiURL: '/api/catalogs/templates/store',
      method: 'POST',
  }),
  computed: {
  },
  mounted() {
  },
  methods: {
      validate() {
        if (this.$refs.form.validate() && this.jsonValid) {
          this.form.busy = true;
          this.store();
        }
      },
      show() {
      },
      store() {
        const formData = new FormData();
        formData.append('file', this.file);
        formData.append('name', this.form.name);
        formData.append('template', this.form.template);
        formData.append('version', this.form.version);
        formData.append('type', this.form.type);
        formData.append('parameters', this.form.parameters);
        formData.append('defaultTemplate', this.form.defaultTemplate);
        const config = {
            headers: {
                'content-type': 'multipart/form-data',
            },
        };

        const URL = `${this.apiURL}`;
        window.axios.post(URL, formData, config)
        .then(() => {
          this.form.busy = false;
          this.$router.go(-1);
        }).catch(() => {
          this.form.busy = false;
        });
      },
      save() {
        this.validate(); // someValue
      },
      cancel() {
        this.$router.go(-1); // someValue
      },
      UpdateJson() {
        try {
            this.jsonValid = true;
            this.titleFormat = 'Formato Json Correcto';
            this.form.data = JSON.parse(this.form.parameters);
            this.$store.dispatch('notifications/show', {
              message: 'Formato Json Correcto',
              type: 'success',
            });
        } catch (e) {
            this.jsonValid = false;
            this.titleFormat = 'Formato Json Invalido';
            this.form.data = {};
            this.$store.dispatch('notifications/show', {
              message: 'Formato Json Invalido',
              type: 'error',
            });
        }
      },
    },
};
</script>
